<template>
  <div
    v-if="!touchDevice"
    v-mouse-custom-pointer
    class="mouse-custom-pointer">
      <div
        class="mouse-custom-pointer__graphic-pointer"
        :class="`mouse-custom-pointer__graphic-pointer--${mouseCursor}`">
        <div
          v-if="typeHasData"
          class="mouse-custom-pointer__graphic-pointer__data-wrapper">
          <div
            v-for="(singularity, index) of mouseCursorData"
            v-html="singularity"
            :key="index"></div>
        </div>
        </div>
    </div>
</template>

<script>
import { styler, spring, listen, value } from 'popmotion'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  data: () => ({
    typeDataMap: ['slider'],
    touchDevice: false
  }),
  computed: {
    ...mapGetters('animations', [
      'mouseCursor',
      'mouseCursorData'
    ]),
    typeHasData: {
      get () {
        return _.includes(this.typeDataMap, this.mouseCursor)
      }
    }
  },
  mounted () {
    window.addEventListener('touchstart', () => { this.touchDevice = true })
    // window.addEventListener('mousemove', () => { this.touchDevice = false })
  },
  directives: {
    'mouse-custom-pointer': {
      bind (el) {
        const divStyler = styler(el)
        const mouseXY = value({ x: -50, y: -50 }, divStyler.set)

        listen(document, 'mousemove mousewheel')
          .start((e) => {
            spring({
              from: mouseXY.get(),
              velocity: mouseXY.getVelocity(),
              to: { x: e.clientX + window.pageXOffset, y: e.clientY + window.pageYOffset },
              stiffness: 200,
              mass: 1,
              damping: 500
            }).start(mouseXY)
          })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../assets/scss/breakpoint.scss';

.mouse-custom-pointer {
  position: absolute;
  z-index: 200;
  pointer-events: none;
}

.mouse-custom-pointer__graphic-pointer {
  position: relative;
  transform: translate3d(-50%, -50%, 0);
  transition: all .5s ease-out;
}

.mouse-custom-pointer__graphic-pointer--default {
  width: 10px;
  height: 10px;
  background-color: #59A3B2;
  border-radius: 50%;
}

.mouse-custom-pointer__graphic-pointer--navigation {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  background-image: url("data:image/svg+xml,%3Csvg width='75px' height='75px' viewBox='0 0 110 110' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 47.1 %2845422%29 - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Edrag%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='DESKTOP' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='AZIENDA' transform='translate%28-1261.000000, -223.000000%29'%3E%3Cg id='Group' transform='translate%2880.000000, 80.000000%29'%3E%3Cg id='drag' transform='translate%281181.000000, 143.000000%29'%3E%3Cg id='Group-2'%3E%3Ccircle id='Oval-3' fill-opacity='0.2' fill='%23000000' cx='55' cy='55' r='55'%3E%3C/circle%3E%3Ccircle id='Oval-2' stroke='%23FFFFFF' stroke-width='2' cx='55' cy='55' r='12'%3E%3C/circle%3E%3Cpolyline id='Path-2' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='square' points='77 50 82 55.5 77 61'%3E%3C/polyline%3E%3Cpolyline id='Path-2-Copy' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='square' transform='translate%2829.500000, 55.500000%29 scale%28-1, 1%29 translate%28-29.500000, -55.500000%29 ' points='27 50 32 55.5 27 61'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");

  @include media(">=large"){
    width: 110px;
    height: 110px;
    background-image: url("data:image/svg+xml,%3Csvg width='110px' height='110px' viewBox='0 0 110 110' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 47.1 %2845422%29 - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3Edrag%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='DESKTOP' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='AZIENDA' transform='translate%28-1261.000000, -223.000000%29'%3E%3Cg id='Group' transform='translate%2880.000000, 80.000000%29'%3E%3Cg id='drag' transform='translate%281181.000000, 143.000000%29'%3E%3Cg id='Group-2'%3E%3Ccircle id='Oval-3' fill-opacity='0.2' fill='%23000000' cx='55' cy='55' r='55'%3E%3C/circle%3E%3Ccircle id='Oval-2' stroke='%23FFFFFF' stroke-width='2' cx='55' cy='55' r='12'%3E%3C/circle%3E%3Cpolyline id='Path-2' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='square' points='77 50 82 55.5 77 61'%3E%3C/polyline%3E%3Cpolyline id='Path-2-Copy' stroke='%23FFFFFF' stroke-width='2' stroke-linecap='square' transform='translate%2829.500000, 55.500000%29 scale%28-1, 1%29 translate%28-29.500000, -55.500000%29 ' points='27 50 32 55.5 27 61'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
}

.mouse-custom-pointer__graphic-pointer--invisble {
  display: none;
}

.mouse-custom-pointer__graphic-pointer--image {
  width: 50px;
  height: 50px;
  background-color: #59A3B2;
}

.mouse-custom-pointer__graphic-pointer--button {
  width: 25px;
  height: 25px;
  background-color: #59A3B2;
  border-radius: 50%;
}

.mouse-custom-pointer__graphic-pointer--slider {
  width: 75px;
  height: 75px;
  background-color: #59A3B2;
  border-radius: 50%;

  @include media(">=large") {
    width: 110px;
    height: 110px;
  }

  &::after, &::before {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    width: 15px;
    height: 15px;
    transform: translateY(-50%);
    background-image: url("data:image/svg+xml,%3Csvg width='9px' height='15px' viewBox='0 0 9 15' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 47.1 %2845422%29 - http://www.bohemiancoding.com/sketch --%3E%3Ctitle%3EPath 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3C/defs%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='square'%3E%3Cg id='drag2' transform='translate%28-219.000000, -52.000000%29' stroke-width='2' stroke='%23FFFFFF'%3E%3Cpolyline id='Path-2' points='221 54 226 59.5 221 65'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    background-repeat: no-repeat;

    @include media(">=large") {
      right: 3px;
    }
  }

  &::before {
    right: auto;
    left: 0;
    transform: translateY(-50%) rotate(180deg);

    @include media(">=large") {
      left: 3px;
    }
  }

  .mouse-custom-pointer__graphic-pointer__data-wrapper {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    color: white;
  }
}

.mouse-custom-pointer__graphic-pointer--video {
  width: 50px;
  height: 50px;
  background-color: #59A3B2;
  border-radius: 50%;
}

.mouse-custom-pointer__graphic-pointer--video--playing {
  width: 50px;
  height: 50px;
  background-color: white;
  border-radius: 50%;
}
</style>
